import i18next from 'i18next';

const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const EMAIL_LIST_SEPARATORS = [',', ' '];

const getRequiredEmailText = () => i18next.t('required');

const getEmailFormatErrorText = (email: string) => i18next.t('_EMAIL_FORMAT_ERROR', { email });

export const validateEmailErrorFormat = (value: string): boolean => {
  const email = value.trim();
  return !EMAIL_VALIDATION_REGEX.test(email);
};

export const checkEmailListErrors = async (values: string[]) => {
  if (!values || values.length === 0) {
    const requiredText = getRequiredEmailText();
    return Promise.reject(requiredText);
  }

  const invalidValue = values.find((value: string) => validateEmailErrorFormat(value));

  if (invalidValue) {
    const emailFormatErrorText = getEmailFormatErrorText(invalidValue);
    return Promise.reject(emailFormatErrorText);
  }

  return Promise.resolve();
};
